<template>
    <!-- FIXME: this would be better suited for a composition of Toggle Group or Tab -->
    <BaseButton
        :theme="isSelected ? 'secondary' : 'neutral'"
        :aria-pressed="isSelected"
        class="w-full flex flex-col gap-y-2 rounded-lgr py-3 px-5 whitespace-normal duration-150 text-start"
        :class="{ 'border border-control-accent': isSelected }"
        @click="$emit('click')">
        <div class="body flex flex-row gap-2.5">
            <i class="bi grow-0" :class="icon" aria-hidden="true"></i>
            <div class="flex flex-col gap-1 grow">
                <div class="body-small-semibold py-1">{{ label }}</div>
                <SkeletonLoader v-if="isLoading" class="w-full h-9 rounded-lgr" />
                <div v-else class="title-section">{{ valueDisplay }}</div>
            </div>
        </div>
    </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
import { formatNumber } from "~vue/utils/formatNumber";
import { computed } from "vue";

const {
    isLoading = false,
    icon = "bi bi-stars",
    label = "",
    value = "",
    isSelected = false,
} = defineProps<{
    isLoading?: boolean;
    icon?: string;
    label?: string;
    value?: string | number;
    isSelected?: boolean;
}>();

defineEmits<{
    click: [];
}>();

const valueDisplay = computed(() => {
    if (typeof value === "number") {
        return formatNumber(value);
    }
    const numberValue = Number.parseFloat(value);
    if (Number.isNaN(numberValue)) {
        return value || "--";
    }
    return formatNumber(numberValue);
});
</script>
